export default {
  // Page title
  title: "Survey Advice",

  // Statistics
  statistics: {
    totalPrefix: "Total",
    totalSuffix: "records",
  },

  // Checkbox
  hideNonKeyPoint: "Hide non-key surveys",

  // Button
  downloadChecklist: "Download Survey Checklist",

  // Loading and empty state
  loading: "Loading...",
  empty: "No data",
  emptyTip:
    "Please right-click on a node in the canvas or click the add survey button on the right",

  // Survey priority
  priority: {
    normal: "Normal Survey",
    high: "Key Survey",
  },

  // Survey status
  status: {
    pending: "Pending",
    success: "Success",
    failed: "Failed",
    waiting: "Waiting for Return",
  },
};
